module.exports = "/_next/static/images/CustomDestinations@2x-a839ab6d1be3be351b55a93f12614506.webp";